import { Message } from "../ui/message";
import { useChat } from "../context/use-chat";
import { Typing } from "./typing";

export const Messages = () => {
  const { messages } = useChat();

  return (
    <div className="flex flex-1 flex-col-reverse overflow-y-auto px-3">
      <Typing />
      {messages.slice(0).map((message, i) => (
        <Message message={message} key={`message-${i}`} />
      ))}
    </div>
  );
};
